import { initialState } from "./state"

export default {
  setSvaUuidEditing: (state, payload) => (state.svaUuidEditing = payload),
  setSvaAlreadyFetchEditing: (state, payload) =>
    (state.svaAlreadyFetchEditing = payload),
  setSvaName: (state, payload) => (state.svaName = payload),
  setSvaPrice: (state, payload) => (state.svaPrice = payload),
  setSvaCategorySelected: (state, payload) =>
    (state.svaCategorySelected = payload),
  setSvaOptionsCategories: (state, payload) =>
    (state.svaOptionsCategories = payload),
  setSvaScore: (state, payload) => (state.svaScore = payload),
  setSvaActive: (state, payload) => (state.svaActive = payload),
  setSvaIcon: (state, payload) => (state.svaIcon = payload),
  setSvaIconPreview: (state, payload) => (state.svaIconPreview = payload),
  setSvaRelatedPlans: (state, payload) => (state.svaRelatedPlans = payload),

  setSvasOptions: (state, payload) => (state.svasOptions = payload),
  setSvaSelecteds: (state, payload) => (state.svasSelecteds = payload),
  addNewSvaSelected(state, newSva) {
    state.svasSelecteds.push(newSva)
  },
  deleteSvaSelected(state, index) {
    state.svasSelecteds.splice(index, 1)
  },
  toggleSvaOptionsDisabled(state, valueSvaSelected) {
    const INDEX_SVA_OPTION = state.svasOptions.findIndex(
      svaOption => svaOption.value === valueSvaSelected
    )
    state.svasOptions[INDEX_SVA_OPTION].disabled =
      !state.svasOptions[INDEX_SVA_OPTION].disabled
  },

  resetSva: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
